import { useSelector } from 'react-redux'
import { profileView } from './storage'
import { Profile, UserRole } from './types'
import { isUserTeacher } from './helpers'

export function useProfile(): Profile | undefined {
  return useSelector(profileView)
}

export function useUserIsTeacher() {
  const profile = useProfile()
  return isUserTeacher(profile?.school?.role)
}

export function useUserIsStudent() {
  const userProfile = useProfile()
  return userProfile?.school?.role === UserRole.STUDENT
}
